import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
  ListItem,
  ListItemText,
  Avatar,
  List,
} from "@mui/material";
import { useEffect, useState } from "react";
import { FieldErrors, useForm, Controller } from "react-hook-form";
import { useQuery, useMutation } from "react-query";
import {
  // useLocation,
  useNavigate,
} from "react-router-dom";
import { FormOnChangeEventType } from "../../EMR/types";
import usePopup from "../../hooks/usePopup";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import {
  ClinicSettingData,
  initialFormData,
  MinistriesType,
  SettingsFormDataType,
  // SettingsTableDataType,
} from "./types";
import {
  getCountry,
  getStates,
} from "../../PatientCare/Patientregistration/v1/registrationServices";
import { getAllMinistries, saveSettingsData } from "./services";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  CountryType,
  StateType,
} from "../../PatientCare/Patientregistration/v1/type/RegistrationDataType";
import ImageIcon from "@mui/icons-material/Image";
import useAuthentication from "@hooks/useAuthentication";

// const pageTitle = "Clinic";
function AddOrEditClinic({ data }: { data: ClinicSettingData | null }) {
  const navigate = useNavigate();
  const {user} = useAuthentication()
  const { control, handleSubmit, reset } = useForm<SettingsFormDataType>({
    defaultValues: initialFormData,
    shouldFocusError: true,
  });
  const [files, setFiles] = useState({
    logo: "",
    letterHead: "",
    letterPad:"" 
  });
  const [validationOpen, setValidationOpen] = useState(false);
  const [missingFields] = useState<string[]>([]);

  const { showSnackbar, CustomModal } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  const { data: ministries, isLoading: ministriesLoading } = useQuery(
    ["ministriesForClinics"],
    getAllMinistries,
    {
      refetchOnWindowFocus: false,
    },
  );

  const { data: countries, isLoading: countriesLoading } = useQuery(
    ["FetchAllCountriesForClinic"],
    getCountry,
    {
      refetchOnWindowFocus: false,
    },
  );

  const {
    mutate: fetchStates,
    isLoading: statesLoading,
    data: states,
  } = useMutation(getStates);

  const { mutate: save, isLoading } = useMutation(saveSettingsData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        // handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.errorMessage ||
          e?.response?.data?.responseMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: SettingsFormDataType) => {
    const params = {
      clinic: {
        address1: value.address || "",
        address2: value.address2 || "",
        clinicId: data?.clinicId || 0,
        commonEntry: value?.fetchCommonEntries,
        country: value.country?.id as number,
        createdById: Number(user?.userId),
        dhpoLicence: value.licenceCode || "",
        domainName: value.domain || "",
        emrPrefix: value.clinicPrefix || "",
        emrLength: Number(value.emrLength || "0"),
        emrSetting: "",
        followUpDays: 0,
        ip: "0.0.0.0",
        isCloudOrLoc: Number(value.storage),
        letterHead: value?.letterHead?.name || "",
        licence: value.licenceCode || "",
        localPath: "D:/",
        lockTime: Number(value.emrlockTime || "0"),
        logo: value?.logo?.name || "",
        ministry: Number(value.ministry?.id),
        password: value.password || "",
        place: value.place || "",
        remarks: value.renarks || "",
        sms: Boolean(value.sms),
        state: Number(value.state?.stateId),
        status: Number(value.status),
        title: value.title || "",
        usedCurrency: value.currencyType || "",
        username: value.username || "",
        whatsapp: Boolean(value.whatsapp),
        reviewLink: value.reviewLink || "",
        zoomUrl: value.zoomUrl || "",
      },
      letterHead: value.letterHead || null,
      logo: value.logo || null,
      letterPad: value.letterPad || null,
    }
    console.log("params => ",params)
    save(params);
  };

  const onInvalid = (errors: FieldErrors<SettingsFormDataType>) => {
    console.log("errors=>",errors)
    // const unfilledFields = Object.keys(errors)
    //   .filter((key) => key !== "password" && key !== "username")
    //   .map(
    //     (key) =>
    //       requiredFieldLabels[key as keyof SettingsFormDataType] ||
    //       key
    //         .replace(/([A-Z])/g, " $1")
    //         .replace(/^./, (char) => char.toUpperCase()),
    //   );

    // if (unfilledFields.length === 0) {
    //   return;
    // }

    // setMissingFields(unfilledFields);
    // setValidationOpen(true);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  const onCountryChange = (e: FormOnChangeEventType) => {
    const { value } = e.target;
    fetchStates(value.id);
  };

  const showFiles = (file: File | null, key: keyof typeof files) => {
    const fileUrl = file ? URL.createObjectURL(file) : "";
    setFiles((prev) => ({
      ...prev,
      [key]: fileUrl,
    }));
  };

  useEffect(() => {
    if (data) {
      if (data.countryId) {
        fetchStates(data.countryId);
      }
      reset({
        address: data.address1,
        address2: data.address2,
        clinicPrefix: data.emrPrefix,
        country: { id: data.countryId, countryName: data.countryName },
        currencyType: data.currencyType,
        domain: data.domainName,
        emrLength: `${data.emrLength}`,
        emrlockTime: `${data.emrLockTime}`,
        fetchCommonEntries: Boolean(data.commonEntry),
        letterHead: null,
        logo: null,
        letterPad: null,
        licenceCode: data.licence,
        ministry: { id: data.ministryId, ministryName: data.ministryName },
        password: "",
        place: data.place,
        renarks: data.remarks,
        state: { stateId: data.stateId, stateName: data.stateName },
        status: Number(data.status),
        storage: Number(data.cloudOrLoc),
        title: data.title,
        sms: Boolean(data.sms),
        username: data.username,
        whatsapp: Boolean(data.whatsapp),
        reviewLink: data.reviewLink || "",
        zoomUrl: data.zoomUrl || "",
      });
      setFiles({
        logo: data?.logo || "",
        letterHead: data?.letterHead || "",
        letterPad: data?.letterPad || "",
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <CustomModal
        open={validationOpen}
        setOpen={setValidationOpen}
        title="Missing required fields"
      >
        <div className="p-4 min-w-[320px] max-w-[420px]">
          <Typography variant="body2" color="text.secondary" className="mb-2">
            Please fill the following fields before saving:
          </Typography>
          <List dense>
            {missingFields.map((field) => (
              <ListItem key={field} sx={{ py: 0.25 }}>
                <ListItemText primary={`• ${field}`} />
              </ListItem>
            ))}
          </List>
          <div className="flex justify-end mt-3">
            <Button
              variant="contained"
              onClick={() => setValidationOpen(false)}
            >
              OK
            </Button>
          </div>
        </div>
      </CustomModal>
      <form onSubmit={handleSubmit(onSubmit, onInvalid)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {/* {data ? "Update" : "Add"} {pageTitle} */}
                Clinic details
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>

              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}

              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {/* {data ? "update" : "save"} */}
                save
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-4">
            <div className="col-span-full flex justify-end gap-2"></div>
            <CustomFormField
              control={control}
              name="title"
              element="input"
              fieldProps={{ label: "Enter title " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="address"
              element="input"
              fieldProps={{ label: "Enter address" }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="address2"
              element="input"
              fieldProps={{ label: "Enter address 2 " }}
              rules={{ required: false }}
            />
            <CustomFormField
              control={control}
              name="place"
              element="input"
              fieldProps={{ label: "Place " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="country"
              element="autocomplete"
              fieldProps={{
                label: "Country",
              }}
              rules={{ required: "Required", onChange: onCountryChange }}
              options={countries?.response || []}
              loading={countriesLoading}
              autocompleteProps={{
                getOptionLabel: (option: CountryType) => option.countryName,
                isOptionEqualToValue: (option: CountryType, value: CountryType) =>
                  option.id === value.id,
                renderOption: (params, option: CountryType) => (
                  <ListItem {...params}>
                    <ListItemText primary={option.countryName} />
                  </ListItem>
                ),
              }}
            />
            <CustomFormField
              control={control}
              name="state"
              element="autocomplete"
              fieldProps={{
                label: "State ",
              }}
              rules={{ required: "Required" }}
              options={states?.response || []}
              loading={statesLoading}
              autocompleteProps={{
                getOptionLabel: (option: StateType) => option.stateName,
                isOptionEqualToValue: (option: StateType, value: StateType) =>
                  option.stateId === value.stateId,
                renderOption: (params, option: StateType) => (
                  <ListItem {...params}>
                    <ListItemText primary={`${option.stateName}`} />
                  </ListItem>
                ),
              }}
            />

            <CustomFormField
              control={control}
              name="ministry"
              element="autocomplete"
              fieldProps={{ label: "Select ministry " }}
              rules={{ required: "Required" }}
              options={ministries?.response || []}
              loading={ministriesLoading}
              autocompleteProps={{
                getOptionLabel: (option: MinistriesType) => option.ministryName,
                isOptionEqualToValue: (
                  option: MinistriesType,
                  value: MinistriesType,
                ) => option.id === value.id,
                renderOption: (params, option: MinistriesType) => (
                  <ListItem {...params}>
                    <ListItemText primary={`${option.ministryName}`} />
                  </ListItem>
                ),
              }}
            />
            <div className="hidden">
              <CustomFormField
                control={control}
                name="username"
                element="input"
                fieldProps={{ label: "Username " }}
                rules={{ required: false }}
              />
              <Controller
                control={control}
                name="password"
                defaultValue=""
                rules={{ required: false }}
                render={({ field }) => (
                  <input
                    {...field}
                    type="password"
                    value={field.value || ""}
                    autoComplete="new-password"
                    tabIndex={-1}
                    aria-hidden="true"
                  />
                )}
              />
            </div>
            <CustomFormField
              control={control}
              name="domain"
              element="input"
              fieldProps={{ label: "Enter domain" }}
              rules={{ required: "Required" }}
            />
          <div>
            <CustomFormField
              control={control}
              name="reviewLink"
              element="input"
              fieldProps={{ label: "Review link" }}
              rules={{ required: false }}
            />
          </div>
          <div>
            <CustomFormField
              control={control}
              name="zoomUrl"
              element="input"
              fieldProps={{ label: "Zoom meeting link" }}
              rules={{ required: false }}
            />
          </div>
            <CustomFormField
              control={control}
              name="licenceCode"
              element="input"
              fieldProps={{ label: "Enter licence code" }}
              rules={{ required: "Required" }}
            />

            <CustomFormField
              control={control}
              name="renarks"
              element="input"
              fieldProps={{ label: "enter remarks " }}
              rules={{ required: false }}
            />
            <CustomFormField
              control={control}
              name="clinicPrefix"
              element="input"
              fieldProps={{ label: "Enter clinic prefix " }}
              rules={{ required: false }}
            />
            {/* <input type="color" /> */}
            <CustomFormField
              control={control}
              name="emrLength"
              element="input"
              fieldProps={{
                label: "Enter length of EMR ",
                placeholder: "Exclude prefix",
              }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="currencyType"
              element="input"
              fieldProps={{ label: "Enter currency type " }}
              rules={{ required: false }}
            />
            <CustomFormField
              control={control}
              name="emrlockTime"
              element="input"
              fieldProps={{ label: "EMR lock time in hours ", type: "number" }}
              rules={{ required: false }}
            />

            <div className="col-span-full grid grid-cols-5 gap-2">
              <CustomFormField
                control={control}
                name="storage"
                element="radio"
                radioProps={{ row: true }}
                radios={[
                  { label: "AWS", value: 1 },
                  { label: "Local", value: 0 },
                ]}
                fieldProps={{ label: "Select storage " }}
                rules={{
                  validate: (value) =>
                    value === 0 ||
                    value === 1 ||
                    value === "0" ||
                    value === "1" ||
                    "Required",
                }}
              />

              <CustomFormField
                control={control}
                name="status"
                element="radio"
                radioProps={{ row: true }}
                radios={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 0 },
                ]}
                fieldProps={{ label: "Status " }}
                rules={{
                  validate: (value) =>
                    value === 0 ||
                    value === 1 ||
                    value === "0" ||
                    value === "1" ||
                    "Required",
                }}
              />

              <CustomFormField
                control={control}
                name="fetchCommonEntries"
                element="checkbox"
                fieldProps={{ label: "Fetch common entries " }}
                rules={{ required: false }}
              />
              <CustomFormField
                control={control}
                name="sms"
                element="checkbox"
                fieldProps={{ label: "SMS " }}
                rules={{ required: false }}
              />
              <CustomFormField
                control={control}
                name="whatsapp"
                element="checkbox"
                fieldProps={{ label: "Whatsapp " }}
                rules={{ required: false }}
              />
            </div>

            <div className="col-span-full grid grid-cols-3 gap-2">
              <label className="flex gap-2 items-center cursor-pointer">
                <div>
                  Select logo{" "}
                  {!Boolean(data) && <span className="text-red-500">*</span>}
                </div>
                <div>
                  <Avatar
                    variant="circular"
                    src={files.logo}
                    sx={{ width: 60, height: 60 }}
                    imgProps={{ style: { objectFit: "contain" } }}
                  >
                    {" "}
                    <ImageIcon />{" "}
                  </Avatar>
                  <Controller
                    name="logo"
                    control={control}
                    defaultValue={null}
                    rules={{
                      required: Boolean(data) ? false : "Logo required",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <input
                          className="hidden"
                          accept=".jpg,.jpeg,.png"
                          type="file"
                          onChange={(e) => {
                            field.onChange(e.target.files && e.target.files[0]);
                            showFiles(
                              e.target.files ? e.target.files[0] : null,
                              "logo",
                            );
                          }}
                        />
                        {Boolean(error) && (
                          <Typography color="error">
                            {error?.message}
                          </Typography>
                        )}
                      </>
                    )}
                  />
                </div>
              </label>

              <label className="flex gap-2 items-center cursor-pointer">
                <div>
                  Select letter head{" "}
                  {!Boolean(data) && <span className="text-red-500">*</span>}
                </div>
                <div className="col-span-2">
                  <Avatar
                    variant="rounded"
                    src={files.letterHead}
                    sx={{ width: 150, height: 60 }}
                    imgProps={{ style: { objectFit: "contain" } }}
                  >
                    {" "}
                    <ImageIcon />{" "}
                  </Avatar>
                  <Controller
                    name="letterHead"
                    control={control}
                    defaultValue={null}
                    rules={{
                      required: Boolean(data) ? false : "Lettre head required",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <input
                          className="hidden"
                          accept=".jpg,.jpeg,.png"
                          type="file"
                          onChange={(e) => {
                            field.onChange(e.target.files && e.target.files[0]);
                            showFiles(
                              e.target.files ? e.target.files[0] : null,
                              "letterHead",
                            );
                          }}
                        />
                        {Boolean(error) && (
                          <Typography color="error">
                            {error?.message}
                          </Typography>
                        )}
                      </>
                    )}
                  />
                </div>
              </label>
              <label className="flex gap-2 items-center cursor-pointer">
                <div>
                  Select letter pad{" "}
                  {!Boolean(data) && <span className="text-red-500">*</span>}
                </div>
                <div className="col-span-2">
                  <Avatar
                    variant="rounded"
                    src={files.letterPad}
                    sx={{ width: 150, height: 60 }}
                    imgProps={{ style: { objectFit: "contain" } }}
                  >
                    {" "}
                    <ImageIcon />{" "}
                  </Avatar>
                  <Controller
                    name="letterPad"
                    control={control}
                    defaultValue={null}
                    rules={{
                      required: Boolean(data) ? false : "Lettre pad required",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <>
                        <input
                          className="hidden"
                          accept=".jpg,.jpeg,.png"
                          type="file"
                          onChange={(e) => {
                            field.onChange(e.target.files && e.target.files[0]);
                            showFiles(
                              e.target.files ? e.target.files[0] : null,
                              "letterPad",
                            );
                          }}
                        />
                        {Boolean(error) && (
                          <Typography color="error">
                            {error?.message}
                          </Typography>
                        )}
                      </>
                    )}
                  />
                </div>
              </label>
            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditClinic;
